// extracted by mini-css-extract-plugin
module.exports = {"listItem":"product-info_listItem__yiQiB"};